export function parseReactivitiesToFloatArray(str) {
  if (!str) return [];

  const trimmed = str.trim();

  if (/\s/.test(trimmed)) {
    return trimmed.split(/\s+/).map((tok) => {
      const v = parseFloat(tok);
      return v <= -10 ? NaN : v;
    });
  }

  const map = { '#': 1.0, '_': 0.0, '+': 0.5 };
  return Array.from(trimmed, (ch) =>
    Object.prototype.hasOwnProperty.call(map, ch) ? map[ch] : NaN
  );
}

const GAP_CHARS = new Set([';', '&', '-', '~', ' ', '\t']);

export function stripGaps(gappedSeq, structure) {
  let seq = '';
  let struct = '';
  for (let i = 0; i < gappedSeq.length; i++) {
    if (!GAP_CHARS.has(gappedSeq[i])) {
      seq += gappedSeq[i];
      struct += structure[i];
    }
  }
  return { sequence: seq, structure: struct };
}

export function stripGapsReactivities(gappedSeq, reactivitiesArr) {
  const out = [];
  for (let i = 0; i < gappedSeq.length; i++) {
    if (!GAP_CHARS.has(gappedSeq[i])) {
      out.push(reactivitiesArr[i]);
    }
  }
  return out;
}
